import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import LaerdalLogo from '../assets/laerdal-logo.svg';
import { BREAKPOINTS, COLORS } from '../styles';

const StyledLink = styled(Link)`
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  &:focus-within {
    outline: none;
  }
  svg {
    width: 66px;
    height: 36px;

    ${BREAKPOINTS.MEDIUM} {
      width: 88px;
      height: 48px;
    }
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  margin-right: 16px;
  box-sizing: border-box;
  padding: 24px 0;

  ${BREAKPOINTS.SMALL} {
    padding: 24px 2px !important;
  }

  ${BREAKPOINTS.MEDIUM} {
    margin-top: 8px;
    margin-bottom: 7px;
    padding: 24px 8px !important;
  }

  &:focus-within {
    box-shadow: 0px 0px 8px #2e7fa1, 0px 4px 12px rgba(46, 127, 161, 0.25);
    outline: none;
  }
`;

const Name = styled.span`
  margin-left: 12px;
  padding-left: 12px;
  border-left: 1px solid ${COLORS.black};
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.02em;
  color: #1f1f1f;

  ${BREAKPOINTS.MEDIUM} {
    font-size: 18px;
  }
`;

const BetaTag = styled.span`
  background-color: ${COLORS.accent2_500};
  color: ${COLORS.white};
  font-weight: bold;
  font-size: 10px;
  padding: 4px;
  line-height: 12px;
  margin-left: 8px;
  margin-top: 2px;
  border-left: none;
`;

type LogoProps = {
  name: string;
  showBetaTag?: boolean;
  onClick?: () => void;
  to?: string;
};

const Logo = ({ name, showBetaTag, onClick, to }: LogoProps): React.ReactElement<LogoProps> => {
  return (
    <LogoContainer>
      <StyledLink
        to={to || '/'}
        onMouseDown={(e: any) => e.preventDefault()}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}>
        <LaerdalLogo />
        <Name>{name}</Name>
        {showBetaTag && <BetaTag>BETA</BetaTag>}
      </StyledLink>
    </LogoContainer>
  );
};

export default Logo;
